import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 21.85 14.16"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M20.92 6.15h-20c-.51 0-.92.41-.92.92s.41.92.92.92h20c.51 0 .92-.41.92-.92s-.41-.92-.92-.92M20.92 12.31h-20c-.51 0-.92.41-.92.92s.41.92.92.92h20c.51 0 .92-.41.92-.92s-.41-.92-.92-.92M.92 1.85h20c.51 0 .92-.41.92-.92s-.41-.92-.92-.92h-20C.41 0 0 .41 0 .92s.41.92.92.92Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }